// Platform detection for the Capacitor iOS shell (ROO-235).
//
// App Store rule 3.1.1: the iOS build must not offer external (Stripe)
// purchases — reader-app model. Gate every purchase entry point behind
// isNativeIOS() so the same web bundle serves both the browser and the shell.
import { Capacitor } from '@capacitor/core';

export function isNativeIOS(): boolean {
  try {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  } catch {
    return false;
  }
}

export function isNativeApp(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}
